import React from 'react'

export default function CompanyCard({ company }) {
    return (
        <div className='skill--card'>
            <img src={company.icon} style={{ height: "40px", width: "40px" }} alt="skill" />
            <div className='skill--info'>
                <p className='skill-name'>{company.name}</p>
            </div>
        </div>
    )
}
